export default {
    install: (app, options) => {
        // ✅ Use glob with eager: true in Vite 4+
        const componentFiles = import.meta.glob(
            '../components/**/*.vue',
            { eager: true }
        );

        Object.entries(componentFiles).forEach(([path, m]) => {
            const componentName = _.upperFirst(
                _.camelCase(path.split('/').pop().replace(/\.\w+$/, ''))
            );

            app.component(componentName, m.default);
        });
    }
};
